import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, ShieldCheckIcon, ClipboardListIcon, FolderOpenIcon } from 'lucide-react';
export function WhatIncludedSection() {
  const items = [{
    icon: <ZapIcon className="w-6 h-6 text-gold" data-id="element-174" />,
    title: 'Guía rápida',
    desc: 'conceptos esenciales sin tecnicismos'
  }, {
    icon: <ShieldCheckIcon className="w-6 h-6 text-gold" data-id="element-175" />,
    title: 'Qué tipo de seguro',
    desc: 'podría tener sentido según tu objetivo (explicado)'
  }, {
    icon: <ClipboardListIcon className="w-6 h-6 text-gold" data-id="element-176" />,
    title: 'Checklist de preguntas',
    desc: 'para comparar pólizas'
  }, {
    icon: <FolderOpenIcon className="w-6 h-6 text-gold" data-id="element-177" />,
    title: 'Organización básica',
    desc: 'de información (para cotizar más rápido)'
  }];
  return <section className="bg-white py-20 px-6" data-id="element-178">
      <div className="max-w-4xl mx-auto" data-id="element-179">
        <div className="text-center mb-16" data-id="element-180">
          <h2 className="font-heading text-3xl md:text-4xl text-navy font-bold" data-id="element-181">
            ¿Qué incluye el ebook?
          </h2>
          <div className="w-16 h-1 bg-gold mx-auto mt-4 rounded-full" data-id="element-182" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-183">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream p-6 rounded-2xl flex items-start gap-4 border border-navy/5 hover:border-gold/30 transition-colors" data-id="element-184">
              <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center flex-shrink-0 shadow-sm" data-id="element-185">
                {item.icon}
              </div>
              <div data-id="element-186">
                <h3 className="font-bold text-navy text-lg mb-1" data-id="element-187">
                  {item.title}
                </h3>
                <p className="text-gray-600" data-id="element-188">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center bg-navy/5 py-6 px-8 rounded-xl border border-navy/10 inline-block mx-auto w-full" data-id="element-189">
          <p className="text-navy font-medium text-lg" data-id="element-190">
            Es un recurso práctico para que no tomes decisiones a ciegas.
          </p>
        </motion.div>
      </div>
    </section>;
}